import React from "react";
import WithdrawalRequest from "./WithdrawalRequest";

// Same payout desk, opened on the "Paid out" tab
const AcceptedWithdrawal = () => <WithdrawalRequest initialTab="accept" />;

export default AcceptedWithdrawal;